import React, { useState } from 'react';
import { Typography } from '@mui/material';

import { PropertyTextInput } from '@paragon/client-tools';
import { Dialog } from '@paragon/popup-state';

export function RenamePresetDialog(props: { name: string; onClose(): void; onRename(name: string): Promise<void> }) {
  const [name, setName] = useState(props.name);

  const [didSavingFail, setDidSavingFail] = useState(false);

  return (
    <Dialog
      insistent
      variant="design"
      title="Rename Preset"
      onCancel={props.onClose}
      submitText="Rename"
      contentSx={{ display: 'flex', flexDirection: 'column' }}
      onSubmit={() => {
        if (name == null || name.trim() === '') {
          return;
        }

        return props
          .onRename(name)
          .then(props.onClose)
          .catch((error) => {
            console.error(error);

            setDidSavingFail(true);
          });
      }}
      actionsNode={
        didSavingFail ? (
          <Typography color="red">Error saving preset. Try again or contact Paragon Support.</Typography>
        ) : null
      }
    >
      <PropertyTextInput
        property="Name"
        value={name}
        error={name == null || name.trim() === ''}
        submit={setName}
        InputProps={{ autoComplete: 'off' }}
      />
    </Dialog>
  );
}
